import { motion } from "framer-motion";

const variants = {
    hidden: { opacity: 0, y: 28 },
    visible: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.7,
            ease: [0.22, 1, 0.36, 1],
            delay: 0.05 * i,
        },
    }),
};

export default function FadeUp({
    children,
    delay = 0,
    className = "",
    once = true,
    as = "div",
    ...rest
}) {
    const Comp = motion[as] || motion.div;
    return (
        <Comp
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={{ once, margin: "-80px" }}
            custom={delay}
            variants={variants}
            {...rest}
        >
            {children}
        </Comp>
    );
}
